import PropTypes from "prop-types"
import styled from "styled-components"
import Image from "next/legacy/image"
import { color, mq } from "helpers/styled"
import Typography from "../styled/Typography"
import List from "./List"
import Conditions from "./Conditions"

export const Wrapper = styled.div`
  display: flex;
  min-height: 120px;
  margin-bottom: 35px;

  @media ${mq("md")} {
    display: block;
    margin-bottom: 0;
  }
`

const Icon = styled.div`
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: white;
  text-align: center;
  padding: 15px 5px;
  border-radius: 14px 0 0 14px;
  width: 100px;

  @media ${mq("md")} {
    flex-direction: row;
    width: auto;
    padding: 5px;
    border-radius: 8px 8px 0 0;

    img {
      width: 24px;
      height: 24px;
    }
  }
`

const Title = styled(Typography)`
  color: ${color("skyBlue")};
  line-height: 21px;

  @media ${mq("md")} {
    padding: 0 10px;
  }
`

const Content = styled.div`
  width: 100%;
  padding: 11px 10px;
  background: ${color("yellow")};
  border-radius: 0 8px 8px 0;

  @media ${mq("md")} {
    border-radius: 0 8px 8px 8px;
  }
`

export default function PreOwnedBanner({ className }) {
  return (
    <Wrapper className={className}>
      <Icon>
        <Image alt="flash" src="/f_svg/static/services/flash" height={48} width={48} />
        <Title variant="title4" weight="bolder">
          Ofertas Flash
        </Title>
      </Icon>
      <Content>
        <List />
        <Conditions />
      </Content>
    </Wrapper>
  )
}

PreOwnedBanner.defaultProps = {
  className: null
}

PreOwnedBanner.propTypes = {
  className: PropTypes.string
}
